import {Task, TaskLevel} from "app/entities/Task";

export class Resource{
  No: string;
  id?: string;
  title: string;
  Title?: string;
  Name: string;
  Tasks?: Task[];
  Hours?: number[];
  groupId?: string;
  CurrentTasksCount?: number;
  CriticalTasksCount?: number;
  ColorCode?: string;
  start?: string;
  end?: string;
  JobTaskNo?: string;
  Customer?: string;
  //resourceExpanded?: boolean;
  Resource_Group_No?: string;
  ResourceGroupName?: string;
  Job_Description?: string;
  Description?: string;
  Icon?: string;
  CalcEstimate?: number;
  Is_Expanded?: boolean;
  Responsible?: string;
  Maintenance_Object?: string;
  App_Task_Category_Description?: string;
  TaskLevel?: TaskLevel;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/Resource.ts